/**
 * ä¸å¡å¨ä½ç±»å
 */
export enum AifBizActionType {
    /**
     * çå
     */
    Creation = 1,

    /**
     * åå
     */
    Writeback = 2
}